import { render } from "./App.vue?vue&type=template&id=d23cb26e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d23cb26e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d23cb26e', __exports__)) {
    api.reload('d23cb26e', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=d23cb26e", () => {
    api.rerender('d23cb26e', render)
  })

}


export default __exports__